export const paginationQueryParamName = 'page';
export const searchQueryParamName = 'search';
